import {Component, EventEmitter, Output} from '@angular/core';
@Component({
    selector: 'app-endcustomer-upgrade-order-complete',
    templateUrl: './endcustomer-upgrade-order-complete.component.html',
    standalone: false
})
export class EndcustomerUpgradeOrderCompleteComponent {
  @Output() next = new EventEmitter();
}
